"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _classnames = _interopRequireDefault(require("classnames"));
var _Multiselect = _interopRequireDefault(require("react-widgets/lib/Multiselect"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _arrowLeft = _interopRequireDefault(require("cccisd-icons/arrow-left7"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross"));
var _eye = _interopRequireDefault(require("cccisd-icons/eye"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _warning = _interopRequireDefault(require("cccisd-icons/warning"));
var _cccisdLaravelFlow = require("cccisd-laravel-flow");
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _Header = _interopRequireDefault(require("../../components/Header"));
var _LackingPermissions = _interopRequireDefault(require("../../components/LackingPermissions"));
var _NoProjectsMessage = _interopRequireDefault(require("../../components/NoProjectsMessage"));
var _questPermissionsByArea = _interopRequireDefault(require("../../helpers/questPermissionsByArea.js"));
var _admin = require("../../selectors/admin.js");
var _Coding = _interopRequireDefault(require("./Coding"));
var _Disabled = _interopRequireDefault(require("./Disabled"));
var _Form = _interopRequireDefault(require("./Form.js"));
var _utils = _interopRequireDefault(require("./Formula/Equation/utils"));
var _Formula = _interopRequireWildcard(require("./Formula"));
var _payload = _interopRequireDefault(require("./Formula/payload"));
var _InputText = _interopRequireDefault(require("./InputText"));
var _metricTypes = require("./metricTypes.js");
var _coding = _interopRequireDefault(require("./coding.graphql"));
var _variables = _interopRequireDefault(require("./variables.graphql"));
var _style = _interopRequireDefault(require("./style.css"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _getMappingValues = _interopRequireDefault(require("./getMappingValues.js"));
var _this = void 0;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var elementIcons = {};
_cccisdLaravelFlow.allElements.forEach(function (element) {
  elementIcons[element.code] = element.icon;
});
var Boilerplate = window.cccisd.boilerplate;
var Fortress = window.cccisd.fortress;
var _default = exports["default"] = function _default(props) {
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isUpdated = _useState2[0],
    setIsUpdated = _useState2[1];
  var _useState3 = (0, _react.useState)(['quantitative', 'qualitative', 'formula', 'additional_coding']),
    _useState4 = _slicedToArray(_useState3, 2),
    metricFilter = _useState4[0],
    setMetricFilter = _useState4[1];
  var _useState5 = (0, _react.useState)(undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    tableActualFilter = _useState6[0],
    setTableActualFilter = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    codingData = _useState8[0],
    setCodingData = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState0 = _slicedToArray(_useState9, 2),
    loading = _useState0[0],
    setLoading = _useState0[1];
  var _useState1 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState1, 2),
    surveyDropdownVisible = _useState10[0],
    setSurveyDropdownVisible = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    metricTypeDropdownVisible = _useState12[0],
    setMetricTypeDropdownVisible = _useState12[1];
  var assignment = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentAssignment)(state.assignment.admin);
  });
  var surveyHandles = (0, _reactRedux.useSelector)(function (state) {
    return state.assignment.admin.currentSurveyHandles;
  });
  var currentProjectId = (0, _reactRedux.useSelector)(function (state) {
    return state.assignment.admin.currentProjectId;
  });
  var currentAssignmentId = (0, _reactRedux.useSelector)(function (state) {
    return state.assignment.admin.currentAssignmentId;
  });
  var devTagsOptions = (0, _reactRedux.useSelector)(function (state) {
    return state.assignment.admin.devTags;
  });
  var tableElement = (0, _react.useRef)(null);
  var canSeeIdentifiable = Fortress.hasAccess('quest.view_identifiable_data', currentProjectId);
  var canEditDevTags = Fortress.hasAccess('quest.dev_tags', currentProjectId);
  var fileName = assignment ? "".concat(assignment.group.group.label, " ").concat(assignment.label).replace(/[\W]+/g, '_') : '';
  var memoSetIsUpdated = function memoSetIsUpdated(value) {
    if (isUpdated !== value) {
      setIsUpdated(value);
    }
  };
  var getCodingData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(hash, variableId) {
      var response, data;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _cccisdApollo.client.query({
              query: _coding["default"],
              variables: {
                assignmentId: [assignment.assignmentId],
                hash: hash
              },
              fetchPolicy: 'network-only'
            });
          case 1:
            response = _context.v;
            data = [];
            response.data.metrics.variableList.forEach(function (item) {
              if (item.tagCount > 0 && !canEditDevTags) {
                return;
              }
              var codeItem = {
                variableId: item.variableId,
                variable: item.reportHeader,
                question: item.key.title,
                codes: Object.keys(item.mapping).map(function (key) {
                  return {
                    label: key,
                    code: item.mapping[key]
                  };
                })
              };
              if (item.variableId === variableId) {
                data.unshift(codeItem);
              } else {
                data.push(codeItem);
              }
            });
            setCodingData(data);
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function getCodingData(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var addAdditionalCoding = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(row) {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return _cccisdAxios["default"].post(Boilerplate.route('api.metrics.variable.store'), {
              keyId: row['key.keyId'],
              reportHeader: row.reportHeader + '_0'
            });
          case 1:
            if (!metricFilter.includes('additional_coding')) {
              setMetricFilter([].concat(_toConsumableArray(metricFilter), ['additional_coding']));
            }
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function addAdditionalCoding(_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  var removeCoding = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(row) {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _context3.n = 1;
            return _cccisdAxios["default"]["delete"](Boilerplate.route('api.metrics.variable.delete', {
              variable: row.variableId
            }));
          case 1:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function removeCoding(_x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  var updateFormula = function updateFormula(setFieldValue, variableId) {
    return /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(values) {
        var putData, response;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              putData = (0, _payload["default"])(values);
              _context4.n = 1;
              return _cccisdAxios["default"].put(Boilerplate.route('api.metrics.formula.update', {
                formula: values.formulaId
              }), putData);
            case 1:
              response = _context4.v;
              if (!(response.data.status === 'success')) {
                _context4.n = 3;
                break;
              }
              setFieldValue("variable".concat(variableId), values.reportHeader);
              setFieldValue("label".concat(variableId), values.label);
              _context4.n = 2;
              return tableElement.current.loadData();
            case 2:
              (0, _cccisdNotification["default"])('Formula has been successfully updated');
              _context4.n = 4;
              break;
            case 3:
              return _context4.a(2, Promise.reject({
                reportHeader: Object.values(response.data.errors).map(function (item) {
                  return item.join(', ');
                }).join(', ')
              }));
            case 4:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      return function (_x5) {
        return _ref4.apply(this, arguments);
      };
    }();
  };
  var deleteFormula = function deleteFormula(formulaId) {
    (0, _cccisdConfirm["default"])({
      message: 'Are you sure?',
      description: 'You are about to delete a formula'
    }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            setLoading(true);
            _context5.n = 1;
            return _cccisdAxios["default"]["delete"](Boilerplate.route('api.metrics.formula.delete', {
              formula: formulaId
            }));
          case 1:
            _context5.n = 2;
            return tableElement.current.loadData();
          case 2:
            setLoading(false);
            (0, _cccisdNotification["default"])('The formula has been successfully deleted');
          case 3:
            return _context5.a(2);
        }
      }, _callee5);
    }))).fail(function () {
      // Do nothing
    });
  };
  var downloadCsv = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.n) {
          case 0:
            _context6.n = 1;
            return tableElement.current.downloadCsv();
          case 1:
            return _context6.a(2);
        }
      }, _callee6);
    }));
    return function downloadCsv() {
      return _ref6.apply(this, arguments);
    };
  }();
  if (!assignment) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Header["default"], {
      showProjectDropdown: true,
      showQuestCount: false,
      showQuestDropdown: true,
      allowAllQuests: false,
      showSurveyDropdown: true,
      surveyDropdownVisible: surveyDropdownVisible,
      setSurveyDropdownVisible: setSurveyDropdownVisible
    }), /*#__PURE__*/_react["default"].createElement(_NoProjectsMessage["default"], null));
  }

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER /////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  if (!Fortress.hasAnyAccess(_questPermissionsByArea["default"].code.permissions, currentProjectId)) {
    return /*#__PURE__*/_react["default"].createElement(_LackingPermissions["default"], null);
  }
  var tableKey = "".concat(currentAssignmentId, "-").concat(surveyHandles.join('-'));
  return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
    loading: loading
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].table
  }, /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
    key: tableKey,
    ref: tableElement,
    query: _variables["default"],
    rowKey: "variableId",
    graphqlVariables: {
      assignmentId: [assignment.assignmentId],
      surveyHandle: surveyHandles || [],
      typeFilter: metricFilter
    },
    filterChangedCallback: function filterChangedCallback(actualFilter) {
      setTableActualFilter(actualFilter);
    },
    disableNavigation: isUpdated,
    disabledNavigationMessage: "You have to save changes first",
    saveState: true,
    csvFilename: fileName + '.csv',
    noRecordsMessage: "No variables to code",
    striped: "key.entityId",
    columns: [{
      name: 'actions',
      label: '',
      rowSpanBy: 'key.entityId',
      hideInCsv: true,
      render: function render(_ref7) {
        var value = _ref7.value,
          row = _ref7.row;
        var type = row['key.entity.type'];

        // show preview only for flow elements
        if (!type || !elementIcons[type]) {
          return null;
        }
        return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
          trigger: /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-primary btn-xs",
            "data-preview-question": row['key.keyId']
          }, /*#__PURE__*/_react["default"].createElement(_eye["default"], null)),
          title: "Question preview"
        }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelFlow.ElementPreview, {
          entityId: row['key.entityId']
        }));
      }
    }, {
      name: 'key.title',
      label: 'Question',
      rowSpanBy: 'key.entityId',
      filter: true,
      hideInCsv: true,
      render: function render(_ref8) {
        var row = _ref8.row,
          value = _ref8.value;
        var type = row['key.entity.type'];
        return type ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].questionType
        }, elementIcons[type] && /*#__PURE__*/_react["default"].createElement("div", null, elementIcons[type]), /*#__PURE__*/_react["default"].createElement("div", null, type)), value) : value;
      }
    }, {
      name: 'key.title',
      label: 'Question',
      hideInTable: true
    }, {
      name: 'key.entity.type',
      label: 'Element Type',
      hideInTable: true
    }, {
      name: 'key.metric',
      label: 'Metric',
      rowSpanBy: 'key.keyId',
      filter: true,
      render: function render(_ref9) {
        var value = _ref9.value,
          row = _ref9.row;
        if (row.type !== 'formula') {
          return value;
        }
        var formulaType = row['formula.type'];
        var variables = value.substring(1, value.length - 1).split(',').map(function (v) {
          return v.trim().replace(/"/g, '');
        }).filter(function (v) {
          return v;
        });
        var warning = function warning(msg) {
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, value), /*#__PURE__*/_react["default"].createElement("p", {
            className: "text-warning"
          }, /*#__PURE__*/_react["default"].createElement(_warning["default"], {
            spaceRight: true
          }), msg));
        };
        if (!variables.length) {
          return warning('Formula is missing needed metrics and is not operational');
        }
        if (formulaType === _Formula.AVERAGE || formulaType === _Formula.SUM) {
          if (row['formula.args.n_input'] > variables.length) {
            return warning('Formula is missing needed metrics and is not operational');
          }
        }
        if (formulaType === _Formula.EQUATION) {
          var unknownVariables = _utils["default"].unknownVariables(row['formula.equation'], variables);
          var missingVariables = _utils["default"].missingVariables(row['formula.equation'], variables);
          if (unknownVariables.length || missingVariables.length) {
            return warning('Formula equation is not operational');
          }
        }
        if (formulaType === _Formula.IF_THEN) {
          var conditionVariables = {
            isValid: true,
            find: function find(findValue) {
              var _this2 = this;
              if ('condition' in findValue) {
                // eslint-disable-next-line react/no-this-in-sfc
                return this.find(findValue.condition);
              }
              if ('conditions' in findValue) {
                return findValue.conditions.map(function (c) {
                  return _this2.find(c);
                });
              }
              if (!variables.includes(findValue.dataConnector.id)) {
                // eslint-disable-next-line react/no-this-in-sfc
                this.isValid = false;
              }
            }
          };
          row['formula.args.conditions'].map(function (condition) {
            return conditionVariables.find(condition);
          });
          if (!conditionVariables.isValid) {
            return warning('Formula conditions are not operational');
          }
        }
        return value;
      }
    }, {
      name: 'reportHeader',
      label: 'Variable',
      filter: true,
      className: _style["default"].minWidth,
      hideInCsv: true,
      render: function render(_ref0) {
        var value = _ref0.value,
          row = _ref0.row,
          customData = _ref0.customData;
        if (customData) {
          var initialValues = customData.initialValues,
            values = customData.values,
            errors = customData.errors;
          var isVariableUpdated = initialValues["variable".concat(row.variableId)] !== values["variable".concat(row.variableId)];
          var hasError = Boolean(errors["variable".concat(row.variableId)]);
          var field = /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            "data-variable-input": row.variableId,
            name: "variable".concat(row.variableId),
            autoComplete: "off",
            component: _InputText["default"]
          });
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].variable
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: (0, _classnames["default"])(hasError && 'is-invalid', isVariableUpdated && _style["default"].isFieldUpdated)
          }, field));
        }
      }
    }, {
      name: 'reportHeader',
      label: 'Variable',
      hideInTable: true
    }, {
      name: 'label',
      label: 'Label',
      filter: true,
      className: _style["default"].minWidth,
      hideInCsv: true,
      render: function render(_ref1) {
        var value = _ref1.value,
          row = _ref1.row,
          customData = _ref1.customData;
        if (customData) {
          var initialValues = customData.initialValues,
            values = customData.values;
          var isLabelUpdated = initialValues["label".concat(row.variableId)] !== values["label".concat(row.variableId)];
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: isLabelUpdated && _style["default"].isFieldUpdated
          }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "label".concat(row.variableId),
            className: "form-control",
            autoComplete: "off"
          }));
        }
      }
    }, {
      name: 'label',
      label: 'Label',
      hideInTable: true
    }, {
      name: 'responseValues',
      label: 'Response Values',
      hideInCsv: true,
      render: function render(_ref10) {
        var value = _ref10.value,
          row = _ref10.row,
          loadData = _ref10.loadData,
          customData = _ref10.customData;
        /* If devTag is set, don't let someone interfere with custom
            developer work by changing the coding values */
        var isDisableEdit = !(0, _isEmpty2["default"])(row.tagList) && !canEditDevTags;
        if (row.type === 'formula') {
          if (isDisableEdit) {
            return null;
          }
          var formulaId = row['formula.formulaId'];
          if (!formulaId) {
            return null;
          }
          var isEditable = Object.prototype.hasOwnProperty.call(row, 'formula.args.isEditable') ? row['formula.args.isEditable'] : true;
          var isDeletable = Object.prototype.hasOwnProperty.call(row, 'formula.args.isDeletable') ? row['formula.args.isDeletable'] : true;
          var initialFormulaVariables = Object.keys(row).filter(function (key) {
            return key.startsWith('formula.input');
          }).map(function (key) {
            return key.slice(14);
          }).filter(function (key) {
            return key.length > 0;
          });
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isEditable && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
            trigger: /*#__PURE__*/_react["default"].createElement("button", {
              type: "button",
              className: "btn btn-primary btn-xs",
              style: {
                marginRight: '0.3em'
              }
            }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null)),
            title: "Edit formula",
            size: "large"
          }, /*#__PURE__*/_react["default"].createElement(_Formula["default"], {
            onSubmit: updateFormula(customData.setFieldValue, row.variableId),
            updatingVariableId: row.variableId,
            initialValues: {
              formulaId: formulaId,
              reportHeader: row.reportHeader,
              label: row.label,
              type: row['formula.type'],
              variables: row['formula.type'] === _Formula.IF_THEN ? [] : initialFormulaVariables,
              calculateCondition: row['formula.args.n_input'] === initialFormulaVariables.length ? 'all' : 'minimum',
              minimumAnswers: row['formula.args.n_input'] === initialFormulaVariables.length ? 1 : row['formula.args.n_input'],
              minimum: row['formula.args.minimum'],
              maximum: row['formula.args.maximum'],
              ifThen: {
                conditions: row['formula.args.conditions'] || [{
                  key: 1,
                  condition: _Formula.initialCondition
                }],
                otherwise: row['formula.args.otherwise'] || '',
                nextKey: row['formula.args.nextKey'] || 2
              },
              equation: row['formula.equation'] || ''
            },
            isUpdating: true
          })), isDeletable && /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-danger btn-xs",
            onClick: deleteFormula.bind(_this, formulaId)
          }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)));
        }
        if (!row.isCodable) {
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, row['key.content.minimum'] && /*#__PURE__*/_react["default"].createElement("div", null, "Min: ", row['key.content.minimum']), row['key.content.maximum'] && /*#__PURE__*/_react["default"].createElement("div", null, "Max: ", row['key.content.maximum']));
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].coding
        }, /*#__PURE__*/_react["default"].createElement("div", null, row.isCodable && (0, _getMappingValues["default"])(row).map(function (item) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: item.label,
            className: _style["default"].codes,
            title: item.label
          }, item.code !== item.label && /*#__PURE__*/_react["default"].createElement("span", null, item.code, /*#__PURE__*/_react["default"].createElement(_arrowLeft["default"], {
            spaceRight: true,
            spaceLeft: true
          })), item.label);
        })), row.isCodable && customData && /*#__PURE__*/_react["default"].createElement("div", null, !isDisableEdit && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
          trigger: /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-primary btn-xs",
            "data-edit-coding": row.variableId
          }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null)),
          title: "Coding",
          size: "calc(100vw - 2em)",
          beforeShow: getCodingData.bind(null, row['key.enumMd5'], row.variableId)
        }, /*#__PURE__*/_react["default"].createElement(_Coding["default"], {
          variableId: row.variableId,
          data: codingData,
          loadData: loadData,
          actualValues: customData && customData.values
        })), !isDisableEdit && row.type === 'additional_coding' && /*#__PURE__*/_react["default"].createElement(_Disabled["default"], {
          disabled: isUpdated
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            marginTop: '0.3em'
          }
        }, /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-danger btn-xs",
          "data-remove-additional-coding": row.variableId,
          onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
            return _regenerator().w(function (_context7) {
              while (1) switch (_context7.n) {
                case 0:
                  setLoading(true);
                  _context7.n = 1;
                  return removeCoding(row);
                case 1:
                  _context7.n = 2;
                  return loadData();
                case 2:
                  setLoading(false);
                case 3:
                  return _context7.a(2);
              }
            }, _callee7);
          }))
        }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)))), row.type === 'quantitative' && !row.hasAdditionalCoding && /*#__PURE__*/_react["default"].createElement(_Disabled["default"], {
          disabled: isUpdated
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            marginTop: '0.3em'
          }
        }, /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-primary btn-xs",
          "data-add-additional-coding": row.variableId,
          onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
            return _regenerator().w(function (_context8) {
              while (1) switch (_context8.n) {
                case 0:
                  setLoading(true);
                  _context8.n = 1;
                  return addAdditionalCoding(row);
                case 1:
                  _context8.n = 2;
                  return loadData();
                case 2:
                  setLoading(false);
                case 3:
                  return _context8.a(2);
              }
            }, _callee8);
          }))
        }, /*#__PURE__*/_react["default"].createElement(_plus["default"], null))))));
      }
    }, {
      name: 'responseValues',
      label: 'Response Values',
      hideInTable: true,
      render: function render(_ref13) {
        var value = _ref13.value,
          row = _ref13.row,
          loadData = _ref13.loadData,
          customData = _ref13.customData;
        if (row.type === 'formula') {
          return null;
        }
        if (!row.isCodable) {
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, row['key.content.minimum'] && "Min: ".concat(row['key.content.minimum'], "\n"), row['key.content.maximum'] && "Max: ".concat(row['key.content.maximum']));
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].coding
        }, /*#__PURE__*/_react["default"].createElement("div", null, row.isCodable && (0, _getMappingValues["default"])(row).map(function (item) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: item.label,
            className: _style["default"].codes,
            title: item.label
          }, item.code !== item.label && "".concat(item.code, " - "), "".concat(item.label, "\n"));
        })));
      }
    }, {
      name: 'type',
      label: 'Metric Type',
      render: function render(_ref14) {
        var value = _ref14.value;
        return _metricTypes.metricTypesMap[value] || '';
      }
    }, {
      name: 'key.isIdentifying',
      label: 'Identifiable',
      hideInCsv: true,
      render: function render(_ref15) {
        var value = _ref15.value,
          row = _ref15.row,
          customData = _ref15.customData;
        var identifiable = canSeeIdentifiable ? /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
          name: "isIdentifying".concat(row.variableId),
          component: _cccisdFormik.CccisdToggle
        }) : /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
          value: row['key.isIdentifying'],
          disabled: true
        });
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].center
        }, identifiable);
      },
      rowSpanBy: 'key.keyId'
    }, {
      name: 'key.isIdentifying',
      label: 'Identifiable',
      hideInTable: true
    }, {
      name: 'key.flow.language',
      label: 'Language',
      rowSpanBy: 'key.entityId',
      filter: true,
      hideInCsv: true,
      filterSettings: {
        type: 'selectbox',
        placeholder: '-- Choose one --',
        options: [{
          label: 'English',
          value: 'en'
        }, {
          label: 'Spanish',
          value: 'es'
        }]
      },
      render: function render(_ref16) {
        var value = _ref16.value,
          row = _ref16.row,
          customData = _ref16.customData;
        var surveysInList = [];
        var _iterator = _createForOfIteratorHelper(row['key.surveyList']),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var surveyList = _step.value;
            var test = surveyList.label;
            if (!surveysInList.includes(test)) {
              surveysInList.push(test);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return /*#__PURE__*/_react["default"].createElement("div", null, surveysInList.join('<br />'), /*#__PURE__*/_react["default"].createElement("br", null), row['key.flow.language']);
      }
    }, {
      name: 'key.surveyList',
      label: 'Survey',
      hideInTable: true,
      render: function render(_ref17) {
        var value = _ref17.value,
          row = _ref17.row,
          customData = _ref17.customData;
        var surveysInList = [];
        var _iterator2 = _createForOfIteratorHelper(row['key.surveyList']),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var surveyList = _step2.value;
            var test = surveyList.label;
            if (!surveysInList.includes(test)) {
              surveysInList.push(test);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        return /*#__PURE__*/_react["default"].createElement("div", null, surveysInList.map(function (item) {
          return "".concat(item, " - ").concat(row['key.flow.language'], "\n");
        }));
      }
    }].concat(_toConsumableArray(canEditDevTags ? [{
      name: 'devTags',
      label: 'Dev tags',
      className: _style["default"].devTags,
      hideInCsv: true,
      render: function render(_ref18) {
        var value = _ref18.value,
          row = _ref18.row,
          customData = _ref18.customData;
        return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
          name: "devTags".concat(row.variableId)
        }, function (_ref19) {
          var field = _ref19.field,
            form = _ref19.form;
          return /*#__PURE__*/_react["default"].createElement(_Multiselect["default"], {
            data: devTagsOptions,
            value: field.value,
            onChange: function onChange(values) {
              form.setFieldValue(field.name, values);
            }
          });
        });
      }
    }, {
      name: 'devTags',
      label: 'Dev tags',
      className: _style["default"].devTags,
      hideInTable: true,
      render: function render(_ref20) {
        var value = _ref20.value,
          row = _ref20.row,
          customData = _ref20.customData;
        var tagList = row.tagList;
        if (!(0, _isEmpty2["default"])(tagList)) {
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, tagList.map(function (item) {
            return "".concat(item.name, "\n");
          }));
        }
        return null;
      }
    }] : [])),
    render: function render(args) {
      return /*#__PURE__*/_react["default"].createElement(_Form["default"], _extends({}, args, {
        downloadCsv: downloadCsv,
        setIsUpdated: memoSetIsUpdated,
        metricFilter: metricFilter,
        tableActualFilter: tableActualFilter,
        setMetricFilter: setMetricFilter,
        assignment: assignment,
        surveyHandles: surveyHandles,
        elementIcons: elementIcons,
        setLoading: setLoading,
        surveyDropdownVisible: surveyDropdownVisible,
        setSurveyDropdownVisible: setSurveyDropdownVisible,
        metricTypeDropdownVisible: metricTypeDropdownVisible,
        setMetricTypeDropdownVisible: setMetricTypeDropdownVisible
      }));
    }
  })));
};